import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SurveyGeocoderPage } from '../device/survey-geocoder.page';
import { SurveyGeocoderBrowserPage } from '../browser/survey-geocoder-browser.page';
import { Capacitor } from '@capacitor/core';

const routes: Routes = [
  {
    path: '',
    component: Capacitor.isNativePlatform() ? SurveyGeocoderPage : SurveyGeocoderBrowserPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyGeocoderPageRoutingModule {}
